import service from '../services';

const buscaRegionaisComDivisoes = async (idUsuario, data) => {
  const regionais = [];

  await service.getAll('Regional', {}, 'list/' + data.idEmpresa).then((res) => {
    res.data.forEach((data) => {
      regionais.push({
        id: data.idRegional,
        label: data.nome + `${data.deletedAt ? '(INATIVO)' : ''}`,
        estado: data.estado,
        cidade: data.cidade,
        divisoes: data.divisoes,
      });
    });
  });

  return regionais;
};

const buscaRegionaisUsuario = async (idUsuario, data) => {
  const regionais = [];
  const { data: regionaisUsuarios } = await service.post(
    'Usuario',
    `find/${idUsuario}`,
    data,
  );

  regionaisUsuarios.forEach((element) => {
    const usuarios_regionais = element.Usuarios_Regional;
    if (usuarios_regionais) {
      regionais.push({
        id: usuarios_regionais.idRegional,
        label: usuarios_regionais.nome,
      });
    }
    const temRegionais =
      element.usuarios_regionais && element.usuarios_regionais.length > 0;

    if (temRegionais) {
      element.usuarios_regionais.forEach((elementSel) => {
        if (usuarios_regionais.idRegional !== elementSel.id_regional)
          regionais.push({
            id: elementSel.id_regional,
            label: elementSel.nome,
          });
      });
    }
  });

  return regionais;
};

const buscaDivisoes = async (data) => {
  const divisoes = [];
  return await service
    .post('CotacaoAberta', 'BuscaDivisao', data)
    .then(({ data }) => {
      data.forEach((element) => {
        divisoes.push({
          id: element.id_divisao,
          label:
            element.nome_divisao + `${element.deletedAt ? '(INATIVO)' : ''}`,
        });
      });
      return divisoes;
    });
};

const buscaRegionais = async (idEmpresa) => {
  const regionais = [];
  return await service
    .getAll('Regional', {}, 'list/idEmpresa=' + idEmpresa)
    .then(({ data }) => {
      data.forEach((element) => {
        regionais.push({
          id: element.idRegional,
          label: element.nome + `${element.deletedAt ? '(INATIVO)' : ''}`,
          estado: element.estado,
          cidade: element.cidade,
          divisoes: element.divisoes,
        });
      });
      return regionais;
    });
};

export default {
  buscaRegionaisComDivisoes,
  buscaRegionaisUsuario,
  buscaDivisoes,
  buscaRegionais,
};
